import React, { Component } from 'react'
import ReceiptLine from '../../components/ReceiptLine'
import ReceiptButton from '../../components/ReceiptButton'
import { connect } from 'react-redux'
import * as resource from '../../constants/Resources'
import * as types from '../../constants/Types'
import * as status from '../../constants/Status'
import { setReceiptModal } from '../../modal/actions/modalActions'
import { getObjectItem, getPriceList, getTranslation } from '../../actions/dataActions'
import { setMessageModal } from '../../actions/generalActions'
import { reprintReceipt } from '../../actions/receiptActions'
import Ink from 'react-ink';
import $ from 'jquery';
import PropTypes from 'prop-types'

class Receipt extends Component {
  constructor(props) {
    super(props);
    this.printBlackBoxReceipt = this.printBlackBoxReceipt.bind(this);
    this.showhidereceipt = this.showhidereceipt.bind(this);
  }

  showhidereceipt() {
    const mainContainer = $('#main-container');
    const receiptKeyboardContainer = $('#receipt-keyboard-container');
    if (receiptKeyboardContainer.css('display') === 'block') {
      mainContainer.css('display', 'block');
      receiptKeyboardContainer.css('display', 'none');
    } else {
      mainContainer.css('display', 'none');
      receiptKeyboardContainer.css('display', 'block');
    }
  }

  printBlackBoxReceipt() {
    let deviceId = 0;
    let posDeviceLinkId = 0;

    this.props.devices.map(device => {
      if (device.printertype === 100
        && device.status === status.PRINTER_OK) {
        deviceId = device.deviceid;
        posDeviceLinkId = device.posdevicelinkid;
      }
      return '';
    });

    if (deviceId > 0
      && posDeviceLinkId > 0) {
      this.props.reprintReceipt(this.props.blackboxReceiptId, deviceId, posDeviceLinkId);
    } else {
      this.props.setMessageModal(true, this.props.getTranslation(resource.NO_WORKING_PRINTER));
    }
  }

  render() {
    let additionalprice = 0;
    const lines = [];
    if (this.props.lines) {
      this.props.lines.map(rec => {
        lines.push(rec);
        if (rec.linetype !== types.SUBTOTAL_LINE) {
          additionalprice += rec.price;
        }
        rec.discount.map(d => {
          additionalprice += d.Price;
          return '';
        })
        return additionalprice;
      })
    }
    
    const confirmButtonText = (this.props.posType === types.POSTYPE_ORDERKIOSK) ? this.props.getTranslation(resource.KIOSK_CONFIRM_ORDER) : this.props.getTranslation(resource.PAY_ORDER);
    const confirmButton = (<ReceiptButton key={2} desc={confirmButtonText} type={types.RECEIPTBUTTON_KIOSK_CONFIRM_ORDER} />);
    
    let stopReceiptButton = '';
    if (!this.props.blackbox) {
      const stopReceiptButtonText = (this.props.posType === types.POSTYPE_ORDERKIOSK) ? this.props.getTranslation(resource.STOP_RECEIPT) : this.props.getTranslation(resource.CANCEL);
      stopReceiptButton = (<ReceiptButton key={1} desc={stopReceiptButtonText} type={types.RECEIPTBUTTON_KIOSK_STOP_RECEIPT} />);
    }

    let title = '';
    if (this.props.objectitemid) {
      title = this.props.getTranslation(resource.LABEL_RECEIPT_ORDERNUMBER);
      const objectItem = this.props.getObjectItem(this.props.objectitemid);
      if (objectItem !== null) {
        title += " " + objectItem.ItemNumber;
      }
      if (this.props.pagerNumber) {
        title += " - " + this.props.getTranslation(resource.PAGER) + " " + this.props.pagerNumber;
      }
    }

    if (this.props.posType === types.POSTYPE_SALESKIOSK && this.props.receiptnumber !== null && this.props.receiptnumber >= 0) {
      title = this.props.getTranslation(resource.LABEL_RECEIPTNUMBER) + " " + this.props.receiptnumber;
      if (this.props.pagerNumber) {
        title += " - " + this.props.getTranslation(resource.PAGER) + " " + this.props.pagerNumber;
      }
    }

    let blackboxReprintButton = '';
    if (this.props.blackboxReceiptId > 0) {
      blackboxReprintButton = (<button onClick={this.printBlackBoxReceipt}>
        <i className="print icon red large">&nbsp;</i><Ink />
      </button>)
    }

    let receiptDetails = (  <i className="browser icon">&nbsp;</i> );
    if (window.matchMedia('(max-width: 768px)').matches) {
      receiptDetails = (<button onClick={this.showhidereceipt}>
        <i className="content icon">&nbsp;</i><Ink />
      </button>);
    }

    return (
      <div className="receipt-container-kiosk">
        <div className="receipt-header">
          <div className="header-icon">
            {receiptDetails}
          </div>
          <div className="header-messagecontainer">
            {title}
          </div>
          <div className="header-icon">
            {blackboxReprintButton}
          </div>
        </div>
        <div className="receipt-body">
          {lines.map(rec =>
              <ReceiptLine key={rec.id}
                lineid={rec.id}
                itemid={rec.itemid}
                description={rec.text}
                configuration={rec.configuration}
                quantity={rec.quantity}
                price={rec.price}
                linetype={rec.linetype}
                editable={rec.editable}
                selected={rec.selected}
                discount={rec.discount}
                weight={rec.weight}
                simpleSeparator={rec.simpleSeparator}/>)}
        </div>
        <div className="receipt-footer">
          <div className="footer-price">
            <div className="price-description">
              {this.props.getTranslation(resource.SUB_TOTAL)}
            </div>
            <div className="price-amount">
              {additionalprice.toFixed(2).replace('.', ',')}
            </div>
          </div>
          <div className="footer-buttons">
            <div className="buttons-button">
              {stopReceiptButton}
            </div>
            <div className="buttons-button">
              {confirmButton}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Receipt.propTypes = {
  lines: PropTypes.array,
  inputquantity: PropTypes.string,
  inputquantitynegative: PropTypes.bool,
  receiptnumber: PropTypes.number,
  blackbox: PropTypes.bool
}

function mapStateToProps(state) {
  return {
    lines: state.receiptState.receipt.lines,
    inputquantity: state.receiptState.input.inputquantity,
    inputquantitynegative: state.receiptState.input.inputquantitynegative,
    receiptnumber: state.receiptState.receipt.receiptnumber,
    objectitemid: state.receiptState.receipt.objectitemid,
    objectitemdescription: state.receiptState.receipt.objectitemdescription,
    blackbox: state.generalState.licenses.blackbox && state.generalState.hasBlackbox,
    objectitemname: state.receiptState.receipt.objectitemname,
    devices: state.generalState.devices,
    blackboxReceiptId: state.generalState.licenses.blackboxReceiptId,
    priceListId: state.receiptState.receipt.pricelistid,
    customer: state.receiptState.receipt.customer,
    posType: state.generalState.posType,
    pagerNumber: state.receiptState.receipt.pagerNumber
  }
}

export default connect(mapStateToProps, { setReceiptModal, getObjectItem, setMessageModal, reprintReceipt, getTranslation, getPriceList })(Receipt)



// WEBPACK FOOTER //
// src/kiosk/components/Receipt.jsx